import React, { useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';
import jsCookie from 'js-cookie';
import { isMobile, isNative } from '@/utils/platform';
import { gotoH5Page } from '@/utils/gotoH5Page';
import { authCookieDomain, ieltsNextWeb } from '@/utils/env';
import { SimpleButton } from '@/components/Simple/SimpleButton';
import i18n from '@/locales/init';

export const withMobileFallbackHOC = (Outlet: (props: { [key: string]: any; }) => JSX.Element) => {
  return React.memo((props: { [key: string]: any; }) => {
    const switchToNewVersion = useMemoizedFn(() => {
      jsCookie.set('VERSION', 'v1', { domain: authCookieDomain });
      window.location.href = ieltsNextWeb;
    });
    useEffect(() => {
      if (isMobile() && !isNative()) {
        const rootEle = document.getElementById('root');
        if (rootEle) {
          rootEle.style.minHeight = 'unset';
          rootEle.style.minWidth = 'unset';
        }
      }
    }, []);

    if (isMobile() && !isNative()) {
      if (gotoH5Page()){
        return '';
      }
      return (
        <div style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          fontSize: '2em',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
          <div>{i18n.t('common.dauyan_account_fallback_not_support_phone')}</div>
          <div>{i18n.t('common.dauyan_account_fallback_goto_pc')}</div>
          <div>
            <SimpleButton duyan_type='standard' style={{
              fontSize: '2rem',
              height: '45px'
            }} onClick={()=>{
              switchToNewVersion();
            }}>{i18n.t('使用新版')}</SimpleButton>
          </div>
        </div>
      );
    }
    return <Outlet {...props} />;
  });
};

